/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Model representing an item in a typeahead search result */
export interface APIGuidTypeaheadModel {
  /**
   * The item id
   * @format uuid
   */
  id?: string;
  /**
   * The name of an item
   * @example "TestName"
   */
  name?: string | null;
}

export interface APIGuidTypeaheadRequestModel {
  /**
   * The value pattern to search
   * @example "abc"
   */
  query?: string | null;
  /**
   * The number of result items to return
   * @format int32
   * @example 5
   */
  count?: number;
  /**
   * Ids to exclude from search result
   * @example [1,2,3]
   */
  excludedIds?: string[] | null;
  /**
   * Ids to include in search result regardless of other criteria
   * @example [4,5,6]
   */
  includedIds?: string[] | null;
  /**
   * The organization ids to filter the search results by
   * @example [101,102]
   */
  organizationIds?: string[] | null;
}

export interface APIOrganizationRequestModel {
  /** @format uuid */
  id: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  isSandbox: boolean;
  /** @maxLength 255 */
  description?: string | null;
  /** @format binary */
  file?: File | null;
}

export interface APISearchSortOrder {
  /**
   * The name of a sort field
   * @default "Id"
   * @example "OrderNumber"
   */
  sortField?: string | null;
  sortOrder?: APISortOrder;
}

export enum APISortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum APIStringOperators {
  Equals = 'Equals',
  NotEquals = 'NotEquals',
  Contains = 'Contains',
  NotContains = 'NotContains',
  StartsWith = 'StartsWith',
  EndsWith = 'EndsWith',
}

/** Filter for string values with various comparison operators */
export interface APIStringSearchFilter {
  condition?: APIStringOperators;
  value?: string | null;
  hasValue?: boolean;
}

/** Filter for decimal values */
export interface APIDecimalSearchFilter {
  condition?: APINumericOperators;
  /** @format double */
  value?: number | null;
  /**
   * Used for "between" condition as the upper bound
   * @format double
   */
  valueTo?: number | null;
  hasValue?: boolean;
}

export enum APINumericOperators {
  Equals = 'Equals',
  NotEquals = 'NotEquals',
  GreaterThanOrEqual = 'GreaterThanOrEqual',
  GreaterThan = 'GreaterThan',
  LessThanOrEqual = 'LessThanOrEqual',
  LessThan = 'LessThan',
  Between = 'Between',
}

export interface APIDateOnlySearchFilter {
  condition?: APIDateTimeOperators;
  /** @format date */
  value?: string | null;
  /**
   * Used for "between" condition as the upper bound
   * @format date
   */
  valueTo?: string | null;
  hasValue?: boolean;
}

export enum APIDateTimeOperators {
  Equals = 'Equals',
  NotEquals = 'NotEquals',
  GreaterThanOrEqual = 'GreaterThanOrEqual',
  GreaterThan = 'GreaterThan',
  LessThanOrEqual = 'LessThanOrEqual',
  LessThan = 'LessThan',
  Between = 'Between',
}

/** Filter for datetime values with various comparison operators */
export interface APIDateTimeSearchFilter {
  condition?: APIDateTimeOperators;
  /** @format date-time */
  value?: string | null;
  /**
   * Used for "between" condition as the upper bound
   * @format date-time
   */
  valueTo?: string | null;
  hasValue?: boolean;
}

export interface APITenantModel {
  /** @format uuid */
  id: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  /** @maxLength 255 */
  description?: string | null;
  isSandbox: boolean;
  /** @maxLength 40 */
  avatar?: string | null;
}

export interface APITenantModelSearchResult {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /** The list of the searched entities */
  result?: APITenantModel[] | null;
}

export interface APITenantQuerySearchFilter {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /** a collection of sort fields */
  searchSortOrders?: APISearchSortOrder[] | null;
  /** The search parameter that will be used to search contains criteria the tenant ids */
  tenantIds?: string[] | null;
  query?: string | null;
}

export interface APIUserAuthModel {
  email?: string | null;
  password?: string | null;
}

export interface APIUserModel {
  /** @format uuid */
  id: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  firstName: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  lastName: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  email: string;
  /**
   * @minLength 1
   * @maxLength 25
   */
  phone: string;
  avatar?: string | null;
  /** @minLength 1 */
  chatHashId: string;
  userType?: APIUserType;
  token?: string | null;
  userTenants: APIUserTenantModel[];
  settings: APIUserSettingModel[];
}

export interface APIUserModelSearchResult {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /** The list of the searched entities */
  result?: APIUserModel[] | null;
}

export interface APIUserPasswordModel {
  /** @minLength 1 */
  currentPassword: string;
  /** @minLength 1 */
  newPassword: string;
}

export interface APIUserRegisterModel {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  password?: string | null;
}

export interface APIUserResetPasswordModel {
  /** @minLength 1 */
  email: string;
  /** @minLength 1 */
  password: string;
  /** @format uuid */
  resetPasswordToken: string;
}

export enum APIUserRight {
  ManageTenant = 'ManageTenant',
  MemberAdministration = 'MemberAdministration',
  SettingsAccess = 'SettingsAccess',
  ApiDocumentationAccess = 'ApiDocumentationAccess',
}

export interface APIUserRightsRequestModel {
  rights: APIUserRight[];
  userType: APIUserType;
}

export interface APIUserSearchFilter {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /** a collection of sort fields */
  searchSortOrders?: APISearchSortOrder[] | null;
  id?: string | null;
  /** Filter for string values with various comparison operators */
  firstName?: APIStringSearchFilter;
  /** Filter for string values with various comparison operators */
  lastName?: APIStringSearchFilter;
  /** Filter for string values with various comparison operators */
  email?: APIStringSearchFilter;
  /** Filter for string values with various comparison operators */
  phone?: APIStringSearchFilter;
  userType?: APIUserType;
  userStatus?: APIUserStatus;
  tenantIds?: string[] | null;
  userRights?: APIUserRight;
}

export interface APIUserSettingModel {
  type?: APIUserSettingType;
  value?: string | null;
}

export enum APIUserSettingType {
  UserTour = 'UserTour',
}

export enum APIUserStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Deleted = 'Deleted',
  NotRegistered = 'NotRegistered',
}

export interface APIUserTenantModel {
  tenant: APITenantModel;
  userType: APIUserType;
  userRights: APIUserTenantRightsModel[];
}

export interface APIUserTenantRightsModel {
  right: APIUserRight;
}

export enum APIUserType {
  User = 'User',
  Admin = 'Admin',
  Editor = 'Editor',
}

export enum APISettingName {
  ECheckPrintLimit = 'ECheckPrintLimit',
  RedirectEmail = 'RedirectEmail',
  Timezone = 'Timezone',
  NewECheckReceiveEmail = 'NewECheckReceiveEmail',
  AddedToOrganizationEmail = 'AddedToOrganizationEmail',
}

export interface APISettingModel {
  name?: APISettingName;
  value?: string | null;
}

export interface APIUserInviteModel {
  firstName: string;
  lastName: string;
  email: string;
}

export enum APIEventType {
  PaymentCreated = 'PaymentCreated',
  PaymentUpdated = 'PaymentUpdated',
  PaymentDeleted = 'PaymentDeleted',
  PaymentVoided = 'PaymentVoided',
  PaymentSent = 'PaymentSent',
  PaymentApproved = 'PaymentApproved',
  PaymentResented = 'PaymentResented',
  PayeeCreated = 'PayeeCreated',
  PayeeUpdated = 'PayeeUpdated',
  PayeeDeleted = 'PayeeDeleted',
  BankCreated = 'BankCreated',
  BankUpdated = 'BankUpdated',
  BankDeleted = 'BankDeleted',
  UserCreated = 'UserCreated',
  UserUpdated = 'UserUpdated',
  UserDeleted = 'UserDeleted',
  UserAddedToOrganization = 'UserAddedToOrganization',
  UserRemovedFromOrganization = 'UserRemovedFromOrganization',
  UserRegistered = 'UserRegistered',
  UserUpdatedOwnProfile = 'UserUpdatedOwnProfile',
  UserRightsUpdated = 'UserRightsUpdated',
  SettingsCreated = 'SettingsCreated',
  SettingsUpdated = 'SettingsUpdated',
}

export enum APIEntityType {
  Payee = 'Payee',
  Payment = 'Payment',
  Bank = 'Bank',
  User = 'User',
  Settings = 'Settings',
}

export interface APIAuditModel {
  /** @format uuid */
  id?: string;
  eventType?: APIEventType;
  entityType?: APIEntityType;
  /** @format uuid */
  entityId?: string;
  data?: string[] | null;
  /** @format date-time */
  createdAt?: string;
  createdBy?: APIUserModel;
}

export interface APIAuditModelSearchResult {
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  result?: APIAuditModel[] | null;
}

export interface APIAuditSearchFilter {
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  searchSortOrders?: APISearchSortOrder[] | null;
  eventType?: APIEventType;
  entityType?: APIEntityType;
  entityId?: string | null;
}
